import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Button, Menu, MenuItem, Divider, Link } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate, useLocation } from 'react-router-dom';
import { contractorAuthService } from '../services/contractorAuthService';
import BrandMark from '../components/BrandMark';

interface ContractorLayoutProps {
  children: React.ReactNode;
}

const ContractorLayout: React.FC<ContractorLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const contractorInfoRaw = typeof window !== 'undefined' ? localStorage.getItem('contractor_info') : null;
  const contractorInfo = contractorInfoRaw ? (() => { try { return JSON.parse(contractorInfoRaw); } catch { return null; } })() : null;

  const open = Boolean(anchorEl);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const go = (path: string) => {
    handleClose();
    if (location.pathname !== path) navigate(path);
  };

  const handleLogout = async () => {
    handleClose();
    try {
      await contractorAuthService.logout();
    } finally {
      navigate('/contractor/auth');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" color="default" sx={{ backgroundColor: '#ffffff', color: '#1f2937', borderBottom: '1px solid #e5e7eb' }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleMenu}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <BrandMark size={24} sx={{ mr: 1 }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Contractor Portal{contractorInfo?.name ? ` — ${contractorInfo.name}` : ''}
            </Typography>
          </Box>
          <Button color="inherit" onClick={() => go('/contractor/dashboard')} startIcon={<DashboardIcon />}>Dashboard</Button>
          <Button color="inherit" onClick={() => go('/contractor/subscription')} startIcon={<CreditCardIcon />}>Subscription</Button>
          <Button color="inherit" onClick={() => go('/contractor/profile')} startIcon={<PersonIcon />}>Profile</Button>
          <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>Logout</Button>
        </Toolbar>
      </AppBar>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} keepMounted>
        <MenuItem onClick={() => go('/contractor/dashboard')}>
          <DashboardIcon fontSize="small" style={{ marginRight: 8 }} /> Dashboard
        </MenuItem>
        <MenuItem onClick={() => go('/contractor/subscription')}>
          <CreditCardIcon fontSize="small" style={{ marginRight: 8 }} /> Subscription
        </MenuItem>
        <MenuItem onClick={() => go('/contractor/profile')}>
          <PersonIcon fontSize="small" style={{ marginRight: 8 }} /> Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <LogoutIcon fontSize="small" style={{ marginRight: 8 }} /> Logout
        </MenuItem>
      </Menu>

      <Box component="main" sx={{ flex: 1, p: 2 }}>
        {children}
      </Box>

		{/* Footer */}
		<Box sx={{ textAlign: 'center', mt: 4, mb: 4 }}>
			<Box sx={{ mt: 6, textAlign: 'center' }}>
				<Link href="/privacy" color="inherit" underline="hover">
					Privacy Policy
				</Link>
			</Box>
			<Box sx={{ mt: 4, textAlign: 'center' }}>
				<Typography variant="body2" color="text.secondary">
					Copyright © 2025 CodePulse PTY LTD
				</Typography>
			</Box>
		</Box>
    </Box>
  );
};

export default ContractorLayout;


